import { InjectOptions, Injector, ProviderToken } from '@angular/core';

export class DialogInjector implements Injector {
  constructor(
    private readonly parent: Injector,
    private readonly extras: WeakMap<object, unknown>,
  ) {}

  get<T>(token: ProviderToken<T>, notFoundValue?: T | null, options?: InjectOptions): T {
    const fromExtras = this.extras.get(token as object) as T | undefined;
    if (fromExtras !== undefined) {
      return fromExtras;
    }
    return this.parent.get<T>(token, notFoundValue ?? null, options);
  }
}
